const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  env: {
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  },
  homePageEvents: {
    initialPage: 1,
    numberOfEventsDisplayed: 8,
  },
  ticketSale: {
    defaultNumberOfAvailableTickets: 20,
  },
  maximumVoucherCodeUses: 10000,
  // registrationPage: {
  //   maximumAcceptedFileSize: 2097152,
  // },
  orderConfirmationPage: {
    viesLink: 'http://ec.europa.eu/taxation_customs/vies/faq.html',
  },
};

export default config;
